// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__J4F8m","rotate":"Loader_rotate__tfaYS"};